
//================================================================
//
// This class holds factories for instantiating the 
// population of controls, pages,  forms, etc.
//
// The module exports only an instance
//
// Lou Mauget, November 20, 2015
//
//================================================================

//---------------------------------------------------------------------------
// import each base control view here:. Some views handle multiple controls
//---------------------------------------------------------------------------

//---------------------------------------------------------------------------
// Need one import for every major factory type (sorry)
//---------------------------------------------------------------------------
import Immutable                          from 'immutable';
import formFactory                        from 'FormFactory.js';
import pageFactory                        from 'PageFactory.js';
import pageInstanceFactory                from 'PageInstanceFactory.js';
import behaviorsPageFactory               from 'BehaviorsPageFactory.js';
import workflowPageFactory                from 'workflow/WorkflowPageFactory.js';

import controlLargeHeadingFactory         from 'ControlLargeHeadingFactory.js';
import controlMediumHeadingFactory        from 'ControlMediumHeadingFactory.js';
import controlSmallHeadingFactory         from 'ControlSmallHeadingFactory.js';
import controlSmallTextFactory            from 'ControlSmallTextFactory.js';
import controlTextFactory                 from 'ControlTextFactory.js';

import controlButtonFactory               from 'ControlButtonFactory.js';
import controlSubmitButtonFactory         from 'ControlSubmitButtonFactory.js';
import controlTableFactory                from 'ControlTableFactory.js';
import controlPictureFactory              from 'ControlPictureFactory.js';
import controlPageButtonFactory           from 'ControlPageButtonFactory.js';
import controlVerticalSeparatorFactory    from 'ControlVerticalSeparatorFactory.js';
import controlHorizontalSeparatorFactory  from 'ControlHorizontalSeparatorFactory.js';
import controlDateCalendarFactory         from 'ControlDateCalendarFactory.js';
import controlInputTextFactory            from 'ControlInputTextFactory.js';
import controlDropDownFactory             from 'ControlDropDownFactory';

import controlTextAreaInputFactory        from 'ControlTextAreaInputFactory.js';
import controlCaptchaFactory              from 'ControlCaptchaFactory.js';
import controlInputNumericFactory         from 'ControlInputNumericFactory.js';
import controlGroupFactory                from 'ControlGroupFactory.js';
import controlBulletTextFactory           from 'ControlBulletTextFactory.js';
import controlInputDateFactory            from 'ControlInputDateFactory.js';
import controlInputTimeFactory            from 'ControlInputTimeFactory.js';
import controlRadioButtonFactory          from 'ControlRadioButtonFactory.js';
import controlCheckboxFactory             from 'ControlCheckboxFactory.js';
import controlMaskedTextFactory           from 'ControlMaskedTextFactory';
import controlPasswordInputFactory        from 'ControlPasswordInputFactory';
import controlProgressBarFactory          from 'ControlProgressBarFactory';
import controlNumericStepperFactory       from 'ControlNumericStepperFactory';
import controlFileAttachmentFactory       from 'ControlFileAttachmentFactory';
import controlListFactory                 from 'ControlListFactory';
import controlSoundAssetFactory           from 'ControlSoundAssetFactory.js';
import controlTimerAssetFactory           from 'ControlTimerAssetFactory.js';
import controlRadioButtonGroupFactory     from 'ControlRadioButtonGroupFactory.js';
import controlMovieFactory                from 'ControlMovieFactory.js';
import controlCheckboxGroupFactory        from 'ControlCheckboxGroupFactory.js'
import controlPrintButtonFactory          from 'ControlPrintButtonFactory.js';
import controlPlayReportButtonFactory     from 'ControlPlayReportButtonFactory.js';
import controlPlayFormButtonFactory       from 'ControlPlayFormButtonFactory.js';
import controlImageImportFactory          from 'ControlImageImportFactory.js';
import controlLinkFactory                 from 'ControlLinkFactory.js';
import controlRankingFactory              from 'ControlRankingFactory.js'
import controlVerticalSliderFactory       from 'ControlVerticalSliderFactory.js';
import controlHorizontalSliderFactory     from 'ControlHorizontalSliderFactory.js';
import controlWebSignatureFactory         from 'ControlWebSignatureFactory.js';
import controlHelloWorldFactory          from 'ControlHelloWorldFactory.js';

import commandGenericFactory              from 'CommandGenericFactory.js';

//reports
import controlFilterInputFactory   from 'reports/ControlFilterInputFactory.js';
import controlClearFilterButtonFactory   from 'reports/ControlClearFilterButtonFactory.js';
import controlValueFactory               from 'reports/ControlValueFactory.js';
import controlLineChartFactory           from 'reports/ControlLineChartFactory.js';
import controlBarChartFactory            from 'reports/ControlBarChartFactory.js';
import controlPieChartFactory            from 'reports/ControlPieChartFactory.js';
import controlDataGridFactory            from 'reports/ControlDataGridFactory.js';
import controlDataListFactory            from 'reports/ControlDataListFactory.js';
import controlGaugeChartFactory          from 'reports/ControlGaugeChartFactory.js';
import controlCrosstabFactory            from 'reports/ControlCrosstabFactory.js';
import controlFilterSelectorFactory      from 'reports/ControlFilterSelectorFactory.js';


//---------------------------------------------------------------------------
// import each behavior control view here.
//---------------------------------------------------------------------------

class FactoryService {

      //===========================================================================================
      // The drag-drop service** refers to this vector to dertermine the initial drag-ghost rectangle
      // the control creation factory. Note that the height and width could be refactored
      // to be properties of each control factory. It was easier for me to fiddle with them 
      // here during development. -Lou Mauget, Dec. 8 2015
      //
      // FormLoad also uses this service. -LEM Sept. 13, 2016
      //===========================================================================================
      get factories() {
        return {

            // Page and form
            // TODO height, width values from theme
            'layout_frame': { height: undefined,   width:  undefined, factory: formFactory, name:'Form' },
            'reports_frame': { height: undefined,   width:  undefined, factory: formFactory, name:'Report' },
            'layout_page':  { height: '900px', width: '700px', factory: pageFactory },
            'page_instance':{ height: undefined, width: undefined, factory: pageInstanceFactory, name: 'Page' },
            // 'behaviors_page': { height: '500px', width: '400px', factory: behaviorsPageFactory },
            'report_page': { height: '500px', width: '400px', factory: pageFactory, name: 'Report' },

            // Controls:
            'control_bar_chart':      {height: '200', width: '240', factory: controlBarChartFactory, name: 'Bar Chart',icon: 'pf-bar-chart'},
            'control_gauge_chart':      {height: '200px', width: '240px', factory: controlGaugeChartFactory, name: 'Gauge Chart',icon: 'pf-gauge-chart'},
            'control_bullet_text':    { height: '51px', width: '76px', factory : controlBulletTextFactory, name : 'Bullet Text', icon: 'pf-bullet-text' },
            'control_button':         { height: '25px', width: '80px', factory: controlButtonFactory, name: 'Button', icon: 'pf-button' },
            'control_captcha':        { height: '40px', width: '160px' ,  factory: controlCaptchaFactory, name: 'Captcha', icon: 'pf-captcha' },
            'control_checkbox':       { height: '18px', width: '77px' , factory: controlCheckboxFactory, name: 'Checkbox', icon: 'pf-checkbox' },
            'control_checkbox_group': { height: '150px', width: '150px', factory: controlCheckboxGroupFactory, name: 'Checkbox Group', icon: 'pf-checkbox-group' },
            'control_crosstab':           {height: '200px', width: '240px', factory: controlCrosstabFactory, name: 'Crosstab',icon: 'pf-crosstab'},
            'control_clear_filter_button': { height: '25px', width: '100px',factory:controlClearFilterButtonFactory, name:'Clear Filter',icon: 'pf-clear-filter'},
            'control_filter_input': { height: '25px', width: '180px',factory:controlFilterInputFactory, name:'Filter Input',icon: 'pf-filter-input', hasLabel: true },
            'control_data_grid':          { height: '200', width: '300', factory: controlDataGridFactory, name: 'Data Grid',icon: 'pf-data-list' },
            'control_data_list':          { height: '200', width: '300', factory: controlDataListFactory, name: 'Data List',icon: 'pf-data-grid' },
            'control_date_calendar':      { height: '200px', width: '174px', factory: controlDateCalendarFactory, name: 'Date Calendar', icon: 'pf-calendar' },
            'control_date_input':         { height: '25px', width: '180px', factory: controlInputDateFactory, name: 'Date Input', icon: 'pf-date-input', hasLabel: true  },
            'control_drop_down':          { height: '25px', width: '180px', factory: controlDropDownFactory, name: 'Drop-Down', icon: 'pf-dropdown', hasLabel: true  },
            'control_file_attachment':    {height: '25px', width: '270px', factory: controlFileAttachmentFactory, name: 'File Attachment', icon: 'pf-file-attachment' },
            'control_filter_selector':    {height: '25px', width: '180px', factory: controlFilterSelectorFactory, name: 'Filter Selector', icon: '.pf-filter-selector', hasLabel: true },
            //'control_filter_setter':      { height: '40px', width: '40px'},  // TODO factory
            //'control_gauge':              { height: '40px', width: '40px'},  // TODO factory
            'control_group':                { height: '80px', width: '164px' ,  factory: controlGroupFactory, name: 'Group', icon: 'pf-group' },
            'control_horizontal_separator': { height: '4px', width:'160px', factory: controlHorizontalSeparatorFactory, name: 'Horizontal Separator', icon: 'pf-horizontal-separator' },
            'control_horizontal_slider':  { height: '44px', width: '160px', factory:controlHorizontalSliderFactory, name:'Horizontal Slider', icon: 'pf-horizontal-slider'},

            //PF-2934. This shall be reactivated later on in a next release.
            //'control_image_input':        { height: '140px', width: '240px', factory: controlImageImportFactory, name: 'Image Import', icon: 'pf-image-import'},

            'control_large_heading':      { height: '32px', width: '185px', factory: controlLargeHeadingFactory, name: 'Large Heading',icon: 'pf-large-heading' },
            'control_line_chart':         { height: '200px', width: '240px', factory: controlLineChartFactory, name: 'Line Chart',icon: 'pf-line-chart'},
            'control_link':               { height: '18px', width: '60px',factory:controlLinkFactory,name:'Link',icon: 'pf-link' },
            'control_list':               { height: '122px', width: '142px' , factory: controlListFactory, name: 'List', icon: 'pf-list'},
            'control_mask_text_input':    { height: '18px', width: '156px', factory: controlMaskedTextFactory, name: 'Mask Text Input', icon: 'pf-mask-text-input', hasLabel: true  },
            'control_medium_heading':     { height: '28px', width: '175px', factory: controlMediumHeadingFactory, name: 'Medium Heading', icon: 'pf-medium-heading' },
            //PF-3980. This shall be reactivated later or in another release.
            // PF-4964 disable control because is no longer usable
            // 'control_movie':              { height: '100px', width: '100px', factory: controlMovieFactory, name:'Movie',icon: 'pf-movie' },
            'control_multiple_text_input': { height: '80px', width: '180px' , factory: controlTextAreaInputFactory, name: 'Multiline Text Input', icon: 'pf-multi-line-text-input', hasLabel: true },
            'control_numeric_input': { height: '25px', width: '180px', factory: controlInputNumericFactory, name: 'Numeric Input', icon: 'pf-numeric-input', hasLabel: true },
            'control_numeric_stepper': { height: '26px', width: '80px', factory: controlNumericStepperFactory, name: 'Numeric Stepper', icon: 'pf-numeric-stepper', hasLabel: true },
            'control_page':         { height: '40px', width: '40px'},
            'control_page_button':  { height: '25px', width: '80px', factory: controlPageButtonFactory, name: 'Page Button',icon: 'pf-show-page' },
            'control_password_input': { height: '25px', width: '180px', factory: controlPasswordInputFactory, name: 'Password Input', icon: 'pf-password-text-input', hasLabel: true },
            'control_picture':      { height: '44px', width: '44px', factory: controlPictureFactory, name: 'Picture',icon: 'pf-picture' },
            'control_pie_chart':    { height: '200', width: '240', factory: controlPieChartFactory, name: 'Pie Chart',icon: 'pf-pie-chart'},
            'control_play_form_button': { height: '25px', width: '100px', factory: controlPlayFormButtonFactory, name: 'Show App Button',icon: 'pf-show-report-button'},
            'control_play_report_button': { height: '25px', width: '100px', factory: controlPlayReportButtonFactory, name: 'Show Report Button',icon: 'pf-show-report-button'},
            'control_print_button': { height: '25px', width: '80px', factory: controlPrintButtonFactory, name: 'Print Button',icon: 'pf-print-button'},
            'control_progress_bar': { height: '28px', width:'200px', factory: controlProgressBarFactory, name: 'Progress Bar' , icon: 'pf-progress-bar'},
            'control_radio_button': { height: '18px', width:'106px', factory: controlRadioButtonFactory, name: 'Radio Button', icon: 'pf-radio-button' },
            'control_radio_button_group': { height: '150px', width:'150px', factory: controlRadioButtonGroupFactory, name: 'Radio Button Group', icon: 'pf-radio-button-group' },
            'control_ranking': { height: '166px', width: '142px', factory: controlRankingFactory, name: 'Ranking', icon: 'pf-ranking'},
            'control_small_heading': { height: '22px', width:' 117px', factory: controlSmallHeadingFactory, name: 'Small Heading',icon: 'pf-small-heading' },
            'control_small_text':    { height: '15px', width:  '50px', factory: controlSmallTextFactory, name: 'Small Text',icon: 'pf-small-text' },
            //PF-3980. This shall be reactivated later or in another release.
            //'control_sound':         { height: '50px', width: '50px', factory: controlSoundAssetFactory, name: 'Sound',icon: 'pf-sound' },
            'control_submit_button': { height: '25px', width:  '80px', factory: controlSubmitButtonFactory, name: 'Submit Button',icon: 'pf-submit-button' },
            'control_table':         { height: '240px', width:'360px', factory: controlTableFactory, name: 'Table', icon: 'pf-table' },
            'control_text':          { height: '18px', width:  '30px', factory: controlTextFactory, name: 'Text',icon: 'pf-text' },
            'control_text_input':    { height: '25px', width: '180px', factory: controlInputTextFactory, name: 'Text Input', icon: 'pf-text-input', hasLabel: true  },
            'control_text_search':   { height: '40px', width: '40px'},  // TODO factory
            'control_time_input':    { height: '25px', width: '180px', factory: controlInputTimeFactory, name: 'Time Input', icon: 'pf-time-input', hasLabel: true  },
            
            'control_timer':         { height: '50px', width: '50px' , factory: controlTimerAssetFactory, name: 'Timer',icon: 'pf-timer' },
            'control_value':         { height: '40px', width: '40px',factory: controlValueFactory, name: 'Value', icon:"pf-value" },
            'control_vertical_separator': { height: '160px', width:'4px', factory: controlVerticalSeparatorFactory, name: "Vertical Separator" ,icon:"pf-vertical-separator" },
            'control_vertical_slider':    { height: '160px', width:'56px', factory: controlVerticalSliderFactory, name: "Vertical Slider" , icon:"pf-vertical-slider"},
            'control_websignature':       { height: '140px', width:'240px', factory: controlWebSignatureFactory, name : 'Web Signature', icon : "pf-web-signature" },
            'control_hello_world':        { height: '18px', width:  '30px', factory: controlHelloWorldFactory, name: 'Text' },
            'control_section':            { height: '100%', width: '100%', factory: controlLargeHeadingFactory, name: 'Section' }
        };
    }



    //===========================================================================================
    // Like factories property, but for behaviors, not layout.
    // Factory params: factory (singleton), name (label text), icon (dom ID of PNG)
    // -Lou Mauget, Jan. 25 2016
    //===========================================================================================
    get behaviorsFactories() {

        return {
            // Page and form
            // TODO height, width values from theme
            'behaviors_frame': { height: undefined,   width:  undefined, factory: formFactory},
            'behaviors_page': { height: '500px', width: '400px', factory: behaviorsPageFactory},

            // Command widgets:
            'command_start': {
                factory: commandGenericFactory,
                name: 'Start',
                type: 'startcommand',
                icon: 'BHI_33',
                width: 40,
                height: 40
            },
            'command_exit': {
                factory: commandGenericFactory, 
                name: 'Exit',
                type: 'exitcommand',
                icon: 'BHI_1',
                width: 30,
                height: 30,
                cancelEvent: "false",
                afterSubmission: "",
                textOrNumber: "",
                fieldValue: "",
                special: "",
                textOrNumberReadOnly: 'readonly',
                specialDisabled: 'disabled'
            },
            'XXcommand_branch': { 
                factory: commandGenericFactory,
                name: 'Simple Branch',
                icon: 'BHI_2',
                width: '150',
                height: '44'
            },
            'XXcommand_case':             { 
                factory: commandGenericFactory,
                name: 'Multiple Branch',
                icon: 'BHI_3',
                width: '150',
                height: '44'
            },
            'command_run':              { 
                factory: commandGenericFactory,
                name: 'Run Behavior',
                type: 'callscript',
                icon: 'BHI_4',
                width: '150',
                height: '44',
                script: '',
                scriptId: ''
            },
            'command_simple_branch': {
                factory: commandGenericFactory,
                name: 'Simple Branch',
                type: 'branchcommand',
                icon: 'BHI_2',
                width: 60,
                height: 60,
                falseConnector: '',
                trueConnector: '',
                fieldName: ''
            },
            'command_multiple_branch':             {
                factory: commandGenericFactory,
                name: 'Multiple Branch',
                type: 'casecommand',
                icon: 'BHI_3',
                width: 60,
                height: 60
            },
            'command_comment': {
                factory: commandGenericFactory,
                name: 'Comment',
                type: 'comment',
                icon: 'BHI_5',
                comments: "",
                text: 'Comment',
                width: '110',
                height: '40'
            },
            'command_submit_data': {
                factory: commandGenericFactory,
                name: 'Submit Data',
                type: 'senddata',
                icon: 'BHI_6',
                selectedFieldName: ''
                ,width: '150', height: '44'
            },
            'command_close': {
                factory: commandGenericFactory, 
                name: 'Close',
                type: 'close',
                icon: 'BHI_7',
                afterSubmission: "",
                textOrNumberReadOnly: 'readonly',
                specialDisabled: 'disabled',
                redirectURLTitle: 'Redirect URL',
                width: '150',
                height: '44',
                closeOption: 'default'
            },
            'command_show_message':     {
                factory: commandGenericFactory,
                name: 'Show Message',
                type: 'showmessage',
                icon: 'BHI_8',
                selectedFieldName: '',
                width: '150',
                height: '44'
            },
            'command_show_page':        {
                factory: commandGenericFactory,
                name: 'Show Page',
                type: 'showpage',
                pageType: 'next',
                icon: 'BHI_9',
                width: '150',
                height: '44'
            },
            'command_show_url':         {
                factory: commandGenericFactory, 
                name: 'Show URL',
                type: 'showurl',
                icon: 'BHI_10',
                textOrNumberReadOnly: 'readonly',
                specialDisabled: 'disabled',
                redirectURLTitle: 'Show URL Settings',
                windowHeight: '150',
                windowWidth: '300',
                windowStyle: 'normal',
                width: '150',
                height: '44'
            },
            'command_cancel_submission':{
                factory: commandGenericFactory,
                name: 'Cancel Submission',
                type: 'cancelsubmission',
                icon: 'BHI_11',
                width: '150',
                height: '44'
            },
            'command_print':            {
                factory: commandGenericFactory, 
                name: 'Print',
                type: 'print',
                icon: 'BHI_12',
                pageType: 'all',
                pageIds: '',
                specificPageDisabled: 'disabled',
                section: 'complete',
                appendixSizePreset: 'letter',
                appendixWidth: '612',
                appendixUnit: 'inch',
                appendixHeight: '792',
                appendixDpi: '72',
                width: '150',
                height: '44',
                printFileName: 'print' // PF-8438
            },
            'command_set_field_value':  { 
                factory: commandGenericFactory,
                name: 'Set Field',
                type: 'setfield',
                icon: 'BHI_13',
                fieldName:'',
                width: '150',
                height: '44'
            },
            'command_copy_field_values':{
                factory: commandGenericFactory, 
                name: 'Copy Fields',
                type: 'copyfields',
                icon: 'BHI_14',
                width: '150',
                height: '44',
                fromFields:[{name:''}],
                toFields:[{name:''}],
                gridData : [
                    {'from': {name:''}, 'to': {name:''}}
                ],
                Property: [{_id: 'fieldsTo', Item: []}, {_id: 'fieldsFrom', Item: []}]
            },
            'command_set_properties':   { 
                factory: commandGenericFactory,
                name: 'Set Property',
                type: 'setproperty',
                icon: 'BHI_15',
                propertyFieldSelected: '',
                propertyFieldIdSelected: '',
                propertyList: [],
                fieldName: '',
                width: '150',
                height: '44'
            },
            'command_show': {
                factory: commandGenericFactory,
                name: 'Show',
                type: 'show',
                icon: 'BHI_16',
                width: '150',
                height: '44'
            },
            'command_set_state': {
                factory: commandGenericFactory,
                name: 'Set State',
                type: 'setstate',
                icon: 'BHI_17',
                width: '150',
                height: '44',
                Property: [{_id: 'states', Item: []}, {_id: 'controls', Item: []}]                
            },
            'command_check_obligatory': {
                factory: commandGenericFactory, 
                name: 'Check Mandatory',
                type: 'checkobligatory',
                icon: 'BHI_18',
                stopExecution: 'true',
                defaultMessage: 'true',
                mandatoryMessageType: 'showDefault',
                message: '',
                width: '150',
                height: '44',
                gridData : [
                    {'name':''},
                    {'name':''},
                    {'name':''}
                ],
                colModel: [
                    {
                        name: 'name',
                        index: 'name',
                        width: 200,
                        editable: false
                    }
                ],
                colNames: ['Object'],
                Property: {_id: 'controls', Item: []}

            },
            'command_set_selection_items':{
                factory: commandGenericFactory,
                name: 'Set Selection Items',
                icon: 'BHI_19',
                type: 'setselection',
                width: '160',
                height: '44',
                currentRow: 0,
                gridData : [],
                colModel: [
                    {
                        name: 'caption',
                        index: 'caption',
                        width: 100,
                        editable: true
                    },
                    {
                        name: 'value',
                        index: 'value',
                        width: 100,
                        editable: true
                    }

                ],
                colNames: ['Caption', 'Value'],
                Property: [{_id: 'captions', Item: []}, {_id: 'values', Item: []}]
            },
            //PF-3980. This shall be reactivated later or in another release.
            'command_start_stop':       {
                factory: commandGenericFactory,
                name: 'Start / Stop',
                type: 'setplayer',
                icon: 'BHI_20',
                startStop: "",
                width: '150',
                height: '44',
                selectedObjectName: '',
                action: 'start'
            },
            'command_set_table_rows':   {
                factory: commandGenericFactory,
                name: 'Set Table Rows',
                type: 'tablerows',
                icon: 'BHI_22',
                width: '150',
                height: '44',
                confirmation: false,
                action: 'addAtBeginning'
            },
            'command_notify':               {
                factory: commandGenericFactory, 
                name: 'Notify',
                type: 'notify',
                icon: 'BHI_22',
                width: '150',
                height: '44',
                gridData : [
                    {'title':'', 'role': ''},
                    {'title':'', 'role': ''},
                    {'title':'', 'role': ''}
                ],
                colModel: [
                {
                    name: 'title',
                    index: 'title',
                    width: 100,
                    editable: false
                },
                {
                    name: 'role',
                    index: 'role',
                    width: 100,
                    editable: false
                }
                
            ],
                colNames: ['Title', 'Role'],
                notifications: []
            },

            'command_set_next_stage':       { 
                factory: commandGenericFactory, 
                name: 'Set Next Stage',
                type: 'setnextstage',
                icon: 'BHI_23',
                width: '150',
                height: '44'
            },
            'command_cancel_notification':  {
                factory: commandGenericFactory,
                name: 'Cancel Notify',
                type: 'cancelnotify',
                icon: 'BHI_24',
                width: '150',
                height: '44',
                cancelNotificationName: '',
                cancelNotificationId: '',
                cancelNotificationType: '2'
            },
            'command_connect':              {
                factory: commandGenericFactory, 
                name: 'Connect',
                type: 'connecttoconnection',
                icon: 'BHI_25',
                width: '150',
                height: '44',
                connectionName: '',
                connectionId: '',
                actionName: '',
                actionId: '',
                ValueOfAField: '',
                maximumRecords: 1000,
                showError: true,
                fielddynamicurl: '',
                fenabled: true,
                gridData : [
                    {'name': '', 'source':'', 'formula': 'selected', 'isDefault':true},
                    {'name': '', 'source':'', 'formula': '', 'isDefault': true},
                    {'name': '', 'source':'', 'formula': '', 'isDefault': true}
                ],
                colModel: [
                    {
                        name: 'name',
                        index: 'name',
                        width: 100,
                        editable: false
                    },
                    {
                        name: 'source',
                        index: 'source',
                        width: 100,
                        editable: false
                    },
                    
                    {
                        name: 'formula',
                        index: 'formula',
                        width: 100,
                        edittype: 'checkbox',
                        editoptions: { value:"selected" },
                        formatter: "checkbox",
                        formatoptions: { disabled: false}
                    },
                    {
                        name: 'isDefault',
                        index: 'isDefault',
                        editable: false,
                        hidden: true
                    }
                    
                ],
                colNames: ['Name', 'Source', 'Formula', 'isDefault'],
                gridData2 : [
                    {'name': '', 'target':'', 'caption': '','value':'','selection':'', 'isDefault': true},
                    {'name': '', 'target':'', 'caption': '','value':'','selection':'', 'isDefault': true},
                    {'name': '', 'target':'', 'caption': '','value':'','selection':'', 'isDefault': true}
                ],
                colModel2: [
                    {
                        name: 'name',
                        index: 'name',
                        width: 100,
                        editable: false
                    },
                    {
                        name: 'target',
                        index: 'target',
                        width: 100,
                        editable: false
                    },
                    {
                        name: 'caption',
                        index: 'caption',
                        width: 40,
                        edittype: 'checkbox',
                        editoptions: { value:"selected" },
                        formatter: 'checkbox',
                        formatoptions: { disabled: false}
                    },
                    {
                        name: 'value',
                        index: 'value',
                        width: 40,
                        edittype: 'checkbox',
                        editoptions: { value:"selected"},
                        formatter: 'checkbox',
                        formatoptions: { disabled: false}
                    },
                    {
                        name: 'select',
                        index: 'select',
                        width: 40,
                        edittype: 'checkbox',
                        editoptions: { value:"selected"},
                        formatter: (cellvalue, options, rowObject) => {                            
                            let disabled = 'disabled';
                            if (options.rowData.caption === 'selected' || options.rowData.value === 'selected'){
                                options.colModel.formatoptions['disabled'] = false;
                                disabled = '';
                            }else{
                                options.rowData.select = '';
                            }

                            let checked = '';
                            if (options.rowData.select === 'selected'){
                                checked = 'checked';
                            }
                            
                            return `<input type="checkbox" value="&nbsp;" ${checked} data-offval="no" ${disabled}>`;
                        },
                        formatoptions: { disabled: true}
                    },
                    {
                        name: 'isDefault',
                        index: 'isDefault',
                        editable: false,
                        hidden: true
                    }
                ],
                colNames2: ['Name','Target','Caption','Value','Select', 'isDefault'],
                Request: {Send: {parameter: []}, Receive: {parameter: []}}
            },
            'command_connect_search':       { 
                factory: commandGenericFactory, 
                name: 'Connect and Search',
                type: 'lookup',
                icon: 'BHI_26',
                connectionName: '',
                connectionId: '',
                actionName: '',
                actionId: '',
                recordsPerPage: '100',
                showError: true,
                dialogWidth:'650',
                dialogHeight:'550',
                dynamicurl: 'false',
                fielddynamicurl: '',
                customURL: '',
                title: "Search",
                ValueOfAField: '',
                message: "",
                width: '150',
                height: '44',
                gridData : [
                    {'search': '', 'name': '', 'source':'', 'formula': 'selected', 'isDefault': true},
                    {'search': '', 'name': '', 'source':'', 'formula': '', 'isDefault': true},
                    {'search': '', 'name': '', 'source':'', 'formula': '', 'isDefault': true}
                ],
                colModel: [
                    {
                        name: 'search',
                        index: 'search',
                        width: 75,
                        edittype: 'checkbox',
                        editoptions: { value:"selected" },
                        formatter: "checkbox",
                        formatoptions: { disabled: false}
                    },
                    {
                        name: 'name',
                        index: 'name',
                        //width: 100,
                        editable: false
                    },
                    {
                        name: 'source',
                        index: 'source',
                        width: 100,
                        editable: false
                    },
                    
                    {
                        name: 'formula',
                        index: 'formula',
                        width: 75,
                        edittype: 'checkbox',
                        editoptions: { value:"selected" },
                        formatter: "checkbox",
                        formatoptions: { disabled: false}
                    },
                    {
                        name: 'isDefault',
                        index: 'isDefault',
                        editable: false,
                        hidden: true
                    }
                    
                ],
                colNames: ['Search', 'Name', 'Source', 'Formula', 'isDefault'],
                gridData2 : [
                    {'show': '', 'name': '', 'target':'', 'items': '', 'isDefaul': true},
                    {'show': '', 'name': '', 'target':'', 'items': '', 'isDefaul': true},
                    {'show': '', 'name': '', 'target':'', 'items': '', 'isDefaul': true}
                ],
                colModel2: [
                    {
                        name: 'show',
                        index: 'show',
                        width: 50,
                        edittype: 'checkbox',
                        editoptions: { value:"selected"},
                        formatter: 'checkbox',
                        formatoptions: { disabled: false}
                    },
                    {
                        name: 'name',
                        index: 'name',
                        width: 100,
                        editable: false
                    },
                    {
                        name: 'target',
                        index: 'target',
                        width: 100,
                        editable: false
                    },
                    {
                        name: 'caption',
                        index: 'caption',
                        width: 40,
                        edittype: 'checkbox',
                        editoptions: { value:"selected" },
                        formatter: 'checkbox',
                        formatoptions: { disabled: false}
                    },
                    {
                        name: 'value',
                        index: 'value',
                        width: 40,
                        edittype: 'checkbox',
                        editoptions: { value:"selected"},
                        formatter: 'checkbox',
                        formatoptions: { disabled: false}
                    },
                    {
                        name: 'select',
                        index: 'select',
                        width: 40,
                        edittype: 'checkbox',
                        editoptions: { value:"selected"},
                        formatter: 'checkbox',
                        formatoptions: { disabled: true}
                    },
                    {
                        name: 'isDefault',
                        index: 'isDefault',
                        editable: false,
                        hidden: true
                    }
                ],
                colNames2: ['Show', 'Name', 'Target', 'Caption','Value','Select', 'isDefault']        ,
                Request: {Send: {parameter: []}, Receive: {parameter: []}}
            },
            'command_transaction': { factory: commandGenericFactory,
                name: 'Transaction',
                type: 'transaction',
                icon: 'BHI_27',
                width: '150',
                height: '44',
                connectionType:'start',
                showErrorMessages: true

            },
            'command_show_form': { factory: commandGenericFactory,
                name: 'Show App',
                type: 'playnew',
                icon: 'BHI_28',
                width: '150',
                height: '44',
                isReport: 'false',
                parentChild:'none',
                formId: '',
                formGUID:'',
                formName:'',
                linkId: '',
                fieldId:'',
                parameterTitle: 'Custom Parameters',
                newWindow:'true',
                showError:'true',
                gridData : [
                    {'name': '', 'source':'', 'selected': 'selected'},
                    {'name': '', 'source':'', 'selected': ''},
                    {'name': '', 'source':'', 'selected': ''}
                ],
                CustomParameters: {parameter: []} },
            'command_show_report': {
                factory: commandGenericFactory,
                name: 'Show Report',
                type: 'playreport',
                icon: 'BHI_29',
                isReport: 'false',
                parentChild:'none',
                reportId: '',
                reportGUID:'',
                reportName:'',
                linkId: '',
                parameterTitle: 'Custom Parameters',
                newWindow:'true',
                showError:'true',
                width: '150',
                height: '44',
                gridData : [
                    {'name': '', 'source':'', 'selected': 'selected'},
                    {'name': '', 'source':'', 'selected': ''},
                    {'name': '', 'source':'', 'selected': ''}
                ],
                colModel: [
                    {
                        name: 'name',
                        index: 'name',
                        width: 100,
                        editable: true
                    },
                    {
                        name: 'source',
                        index: 'source',
                        width: 100,
                        editable: false
                    },
                    
                    {
                        edittype:'checkbox',
                        editoptions: { value:"True:False"}, 
                        formatter: "checkbox", 
                        formatoptions: {disabled : false},
                        name: 'formula',
                        index: 'formula',
                        width: 30,
                        editable: true
                    }
                    
                ],
                colNames: ['Name', 'Source', 'Formula']  ,
                CustomParameters: {parameter: []} },
            //PF-3980. This shall be reactivated later or in another release.
            'command_get_field_from_other': {
                factory: commandGenericFactory,
                name: 'Get Field from Other Instance',
                type: 'getfieldfromform',
                icon: 'BHI_30',
                formId: '',
                formGUID:'',
                formName:'',
                targetFieldName: '',
                //textOrNumberReadOnly: 'readonly',
                //specialDisabled: 'disabled',
                //redirectURLTitle: 'Form Instance ID',
                width: '200',
                height: '44'
            },
            //PF-3980. This shall be reactivated later or in another release.
            'command_set_field_in_other':   { factory: commandGenericFactory,
                name: 'Set Field in Other Instance',
                type: 'setfieldinform',
                icon: 'BHI_31',
                selectedFieldName: '',
                selectedInstanceFieldName: '',
                selectedValueFieldName: '',
                height: '44',
                width:'200'
            },
            'command_call_javascript':      { factory: commandGenericFactory,
                name: 'Call JavaScript',
                type: 'javascript',
                icon: 'BHI_32',
                width: '150',
                height: '44',
                functionName: '',
                parameterTitle: 'Parameters',
                returnValueTarget: '',
                CustomParameters: {parameter: []} },
            'control_report_refresh':       {
                factory: commandGenericFactory,
                name: 'Refresh Report',
                type: 'refreshreport',
                icon: 'BHI_23',
                width: '150',
                height: '44'
            },
            'control_set_filter':       {
                factory: commandGenericFactory,
                name: 'Set Filter',
                type: 'setfilter',
                icon: 'BHI_23',
                width: '150',
                height: '44',
                operator: 'equal'
            },
            'control_clear_filter':       {
                factory: commandGenericFactory,
                name: 'Clear Filter',
                type: 'clearfilter',
                icon: 'BHI_23',
                width: '150',
                height: '44'
            },
            'workflow_frame': { height: undefined,   width:  undefined,factory: formFactory},
            'workflow_page': { height: undefined,   width:  undefined,factory: workflowPageFactory}
        }
    }



    //===========================================================================================
    // Reverse index of behaviorsFactories. Indexed by command type.
    //===========================================================================================
    getBehaviorsFactoryByType( pfType ) {
        if (!this._commandIndex) {
            const index = {};
            _.forEach( this.behaviorsFactories, (factory, factoryKey) => {
                index[ factory.type ] = factory;
                factory.factoryKey = factoryKey; // So reverse lookup can know the original key
            });
            this._commandIndex = Immutable.Map( index );
        }
        return this._commandIndex.get( pfType );
    }


    //===========================================================================================
    // Like factories property, but for workflow, not layout.
    // Factory params: factory (singleton), name (label text), icon (dom ID of PNG)
    // -Rene Lopez, Apr. 4 2016
    //===========================================================================================
    get workflowFactories() {
        return {
            // Page and form
            // Custom Form and Page for Workflow View.
            'workflow_frame': { height: undefined,   width:  undefined,factory: formFactory},
            'workflow_page': { height: undefined,   width:  undefined,factory: workflowPageFactory},


            'workflow_stage' : {
                factory: commandGenericFactory,
                name: 'Stage',
                stageName: '',
                isDefault: '',
                isClosed: '',
                width: '150',
                height: '44',
                fillColor: '#d7d7f4'
            },
            'workflow_comment' : { 
                factory: commandGenericFactory, 
                name: 'Comment',
                attributeName: '',
                comments: "",
                text: '',
                width: '150',
                height: '100'}
        };
    }


}

const factoryService = new FactoryService();
export default factoryService;
